import { Component } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import Raven from 'raven-js';
import apiClient from 'hub-http/clients/noAuthApiClient';
import * as PresentationsV1PublicApi from '../../api/PresentationsV1PublicApi';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
// @ts-expect-error No types
import LegalConsentFields from 'FormsCommonComponents/LegalConsentFields';
// @ts-expect-error No types
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { TextInput } from 'foundations-components/transitional/components/TextInput';

// @ts-expect-error No types
import UIValidatedEmailFormControl from 'ui-addon-form-validation/Email/UIValidatedEmailFormControl';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { isChirpEnabled } from '../../utils/isChirpEnabled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class ViewerInfoModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      email: '',
      isEmailValid: false,
      consentToCommunicate: false
    };
    this.handleChange = event => {
      this.setState({
        email: event.target.value
      });
    };
    this.handleKeyDown = event => {
      if (event.key === 'Enter' && this.state.email.length > 0) {
        this.handleSubmit();
      }
    };
    this.handleSubmitCHIRP = () => {
      const {
        presentationId,
        accessId,
        legalConsentCHIRP,
        onConfirm
      } = this.props;
      const {
        email,
        consentToCommunicate
      } = this.state;
      if (legalConsentCHIRP && legalConsentCHIRP.documentLegalConsentEnabled && legalConsentCHIRP.legalConsentOptions && presentationId && accessId) {
        void PresentationsV1PublicApi.postLegalConsentFeedbackCHIRP({
          documentId: presentationId,
          accessId,
          email,
          consentReceived: consentToCommunicate,
          legalConsentOptions: legalConsentCHIRP.legalConsentOptions,
          formGuid: (legalConsentCHIRP === null || legalConsentCHIRP === void 0 ? void 0 : legalConsentCHIRP.consentFormId) || ''
          // TODO: do I need communicationTypeId here?
        }).then(() => {
          onConfirm({
            email
          });
        }).catch(err => {
          FloatingAlertStore.addAlert({
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "view.gdprSubmissionError.title"
            }),
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "view.gdprSubmissionError.message"
            }),
            type: 'danger'
          });
          Raven.captureException(new Error(`Documents legal consent form submission error ${err.status}`), err);
        });
      }
    };
    this.handleSubmit = () => {
      const {
        presentationId,
        accessId,
        legalConsent,
        onConfirm
      } = this.props;
      const {
        email,
        consentToCommunicate
      } = this.state;
      if (legalConsent && legalConsent.deckLegalConsentEnabled && legalConsent.legalConsentOptions && legalConsent.legalConsentOptions.communicationConsentCheckboxes && presentationId && accessId) {
        PresentationsV1PublicApi.postLegalConsentFeedback({
          presentationId,
          accessId,
          email,
          formGuid: legalConsent.consentFormId,
          communicationTypeId: legalConsent.legalConsentOptions.communicationConsentCheckboxes[0].communicationTypeId,
          deckLegalConsentEnabled: legalConsent.deckLegalConsentEnabled,
          consentReceived: consentToCommunicate,
          legalConsentOptions: legalConsent.legalConsentOptions.toJS()
        }).then(() => {
          onConfirm({
            email
          });
        }).catch(err => {
          FloatingAlertStore.addAlert({
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "view.gdprSubmissionError.title"
            }),
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "view.gdprSubmissionError.message"
            }),
            type: 'danger'
          });
          Raven.captureException(new Error(`Documents legal consent form submission error ${err.status}`), err);
        });
      }
      return onConfirm({
        email
      });
    };
    this.renderTitle = () => {
      const {
        givenName,
        familyName
      } = this.props;
      if (givenName && givenName.length > 0 && familyName && familyName.length > 0) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "view.viewerInfo.header.title.withName",
          "data-test-id": "view-info-gdpr-title",
          options: {
            name: /*#__PURE__*/_jsx(FormattedName, {
              givenName: givenName,
              familyName: familyName
            })
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "view.viewerInfo.header.title.noName"
      });
    };
    this.renderLegalConsent = () => {
      const isUngatedToChirp = isChirpEnabled();
      const {
        legalConsent: legalConsentREST,
        legalConsentCHIRP
      } = this.props;
      const legalConsent = isUngatedToChirp ? legalConsentCHIRP : legalConsentREST;
      const legalConsentEnabled = isUngatedToChirp ? legalConsentCHIRP === null || legalConsentCHIRP === void 0 ? void 0 : legalConsentCHIRP.documentLegalConsentEnabled : legalConsentREST === null || legalConsentREST === void 0 ? void 0 : legalConsentREST.deckLegalConsentEnabled;
      if (!legalConsent || !legalConsentEnabled) {
        return null;
      }
      const legalConsentOptions = isUngatedToChirp ? legalConsentCHIRP === null || legalConsentCHIRP === void 0 ? void 0 : legalConsentCHIRP.legalConsentOptions : legalConsentREST === null || legalConsentREST === void 0 ? void 0 : legalConsentREST.legalConsentOptions.toJS();
      const previewModel = new LegalConsent(legalConsentOptions);
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(LegalConsentFields, {
          legalConsentRecord: previewModel,
          onCommunicationCheckboxChange: (_consentCopy, consentToCommunicate) => this.setState({
            consentToCommunicate
          })
        })
      });
    };
  }
  render() {
    const {
      email,
      isEmailValid
    } = this.state;
    const isUngatedToChirp = isChirpEnabled();
    return /*#__PURE__*/_jsxs(Modal, {
      width: 600,
      "data-test-id": "viewer-info-prompt",
      children: [/*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlock: "400",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h4",
            marginBlockEnd: "400",
            textAlign: "start",
            children: this.renderTitle()
          })
        }), /*#__PURE__*/_jsx(UIValidatedEmailFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "view.viewerInfo.header.subtitle"
          }),
          required: true,
          httpClient: apiClient,
          type: "apiFast",
          onSuccess: () => this.setState({
            isEmailValid: true
          }),
          onError: () => this.setState({
            isEmailValid: false
          }),
          align: "start",
          children: /*#__PURE__*/_jsx(TextInput, {
            autoFocus: true,
            "data-selenium-test": "view-info-gdpr-email-input",
            onChange: this.handleChange,
            onKeyDown: this.handleKeyDown,
            value: email
          })
        }), this.renderLegalConsent()]
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          "data-selenium-test": "view-info-gdpr-submit-button",
          use: "primary",
          onClick: isUngatedToChirp ? this.handleSubmitCHIRP : this.handleSubmit,
          disabled: email.length === 0 || !isEmailValid,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "view.viewerInfo.submit"
          })
        })
      })]
    });
  }
}